import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { finalize } from 'rxjs/operators';

import { LoadingAlertProvider } from '../../../providers/loading-alert/loading-alert';
import { OpsProvider } from '../../../providers/ops/ops';
import { OpsVehicleModel } from '../../../models/vehicle.ops';

@Component({
  selector: 'ysh-mileage',
  templateUrl: './mileage.html',
})
export class VehicleMileagePage {
  vehicle: OpsVehicleModel;
  userInputMiles: number;

  constructor(
    private viewController: ViewController,
    private loadingAlert: LoadingAlertProvider,
    private opsService: OpsProvider,
    private params: NavParams
  ) {
    this.vehicle = this.params.get('vehicle');
  }

  didTapAddMiles() {
    this.loadingAlert.showLoader();
    this.opsService
      .saveMiles(this.vehicle, this.userInputMiles)
      .pipe(finalize(() => this.loadingAlert.dismissLoader()))
      .subscribe(
        response => {
          this.userInputMiles = null;
          this.viewController.dismiss(response.miles);
          this.loadingAlert.showToastConfirmation('Mileage Saved!');
        },
        error => this.loadingAlert.showToastAlert(error)
      );
  }

  didTapDismiss() {
    this.viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fleet/mileage/mileage.ts